import { render } from "./DateRangePicker.vue?vue&type=template&id=0c52d10c"
import script from "./DateRangePicker.vue?vue&type=script&lang=js"
export * from "./DateRangePicker.vue?vue&type=script&lang=js"

import "./DateRangePicker.vue?vue&type=style&index=0&id=0c52d10c&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__